const PaymentModel = {code:null, label:null, delivered:0, reference:null};

export default PaymentModel;